import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-dropdown-item',
  imports: [],
  templateUrl: './dropdown-item.component.html',
  styleUrl: './dropdown-item.component.css',
})
export class DropdownItemComponent {
  disabled = input<boolean>(false);
  title = input<string>('');

  itemClick = output<void>();

  onClick() {
    if (this.disabled()) return;
    this.itemClick.emit();
  }
}
